// Campus photo for /colleges/drexel-university: CC BY 2.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMain_Building_-_Drexel_University_(53590618820).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/drexel-university/; credited under the photo.
const photo = {
    "slug": "drexel-university",
    "alt": "Drexel University's Main Building, a tan stone building on a street corner at 32nd Street in Philadelphia, under a clear blue sky",
    "src": "/colleges/drexel-university/campus-1600.webp",
    "srcSmall": "/colleges/drexel-university/campus-800.webp",
    "srcMid": "/colleges/drexel-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/drexel-university/og.jpg",
    "title": "Main Building - Drexel University (53590618820)",
    "author": "ajay_suresh",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMain_Building_-_Drexel_University_(53590618820).jpg",
    "read": "2026-10-01"
};

export default photo;
